// src/persist/migrateBothWays.js
import localforage from "localforage";

/** Redux-Persist key */
const PERSIST_KEY = "persist:root";


// pgw 11-feb-2026
let doprint = false;
// let doprint = true;


/** LocalForage instance for Redux-Persist (IDB backend) */
export const lf = localforage.createInstance({
  name: "ChoirPlayer",
  storeName: "persistRoot",
  driver: [
    localforage.INDEXEDDB,
    localforage.WEBSQL,
    localforage.LOCALSTORAGE,
  ],
});

/* -------------------- raw read/write helpers -------------------- */
async function readFromIDB() {
  await lf.ready();
  return lf.getItem(PERSIST_KEY);
}
async function writeToIDB(raw) {
  await lf.ready();
  return lf.setItem(PERSIST_KEY, raw);
}
function readFromLS() {
  try { return window.localStorage.getItem(PERSIST_KEY); } catch { return null; }
}
function writeToLS(raw) {
  window.localStorage.setItem(PERSIST_KEY, raw);
}

/* -------------------- preflight copy (blocking) -------------------- */
/** Copy LS → IDB if LS has blob and IDB does not. */
export async function preflightCopyLsToIdb() {
  if (typeof window === "undefined") return false;

  const lsBlob = readFromLS();
  if (lsBlob == null) {
    if (doprint) console.log("[preflight] LS→IDB: no LS blob — skip");
    return false;
  }

  const idbBlob = await readFromIDB();
  if (idbBlob != null) {
    if (doprint) console.log("[preflight] LS→IDB: IDB already has blob — skip");
    return false;
  }

  await writeToIDB(lsBlob);
  if (doprint) console.log("[preflight] LS→IDB: copied raw persist:root");
  return true;
}

/** Copy IDB → LS if IDB has blob and LS does not. */
export async function preflightCopyIdbToLs() {
  if (typeof window === "undefined") return false;

  const idbBlob = await readFromIDB();
  if (idbBlob == null) {
    if (doprint) console.log("[preflight] IDB→LS: no IDB blob — skip");
    return false;
  }

  const lsBlob = readFromLS();
  if (lsBlob != null) {
    if (doprint) console.log("[preflight] IDB→LS: LS already has blob — skip");
    return false;
  }

  writeToLS(idbBlob);
  if (doprint) console.log("[preflight] IDB→LS: copied raw persist:root");
  return true;
}

/** Ensure target backend has blob before hydrate. */
export async function ensureTargetHasBlob(target = "idb") {
  if (target === "idb") return preflightCopyLsToIdb();
  if (target === "ls")  return preflightCopyIdbToLs();
  if (doprint) console.warn("[preflight] Unknown target:", target);
  return false;
}

/* -------------------- cleanup helpers (expected by store.js) -------------------- */
/** Remove ONLY the persisted key from LocalStorage (leave other data intact). */
export function cleanupLegacyLocalStorage({ lsKey = PERSIST_KEY } = {}) {
  try {
    window.localStorage.removeItem(lsKey);
    if (doprint) console.log("[cleanup] LocalStorage removed key:", lsKey);
  } catch (e) {
    console.warn("[cleanup] LocalStorage remove failed:", e);
  }
}

/** Remove ONLY the persisted key from IndexedDB (leave DB intact). */
export async function cleanupLegacyIndexedDB({ lfKey = PERSIST_KEY } = {}) {
  try {
    await lf.ready();
    await lf.removeItem(lfKey);
    if (doprint) console.log("[cleanup] IDB removed key:", lfKey);
  } catch (e) {
    console.warn("[cleanup] IDB remove failed:", e);
  }
}

export default {
  lf,
  preflightCopyLsToIdb,
  preflightCopyIdbToLs,
  ensureTargetHasBlob,
  cleanupLegacyLocalStorage,
  cleanupLegacyIndexedDB,
};